import React from 'react'
import SquareButton from '../SquareButton'


const HomeScrollSectionOne = () => {
    return (
        <>
            <div id="section-one" className="background-container d-flex align-items-center">
                <video className="background-video" autoPlay muted loop>
                    <source src="/video/background-video.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <main className="row">
                    <div className="col-md-6">
                        <div className="z-1 position-relative ms-4 text-white">
                            <h1 className='text_36_home'>WELCOME TO IMMSY</h1>
                            <p className='text_18_home'>
                                The all-in-one platform for personalized well-being. Discover, create, and experience unique wellness journeys with IMMSY.
                                EXPLORE IMMSY
                            </p>
                            <div>
                                <SquareButton value={'EXPLORE IMMSY'} />
                            </div>
                        </div>
                    </div>
                </main>

                <aside className="progress-indicator">
                    <div className="indicator-item active"></div>
                    <div className="indicator-item"></div>
                    <div className="indicator-item"></div>
                </aside>
            </div>
        </>
    )
}

export default HomeScrollSectionOne

